/* Rune — Custom Cart Drawer */

(function () {
  const drawer     = document.getElementById('runeCartDrawer');
  if (!drawer) return;

  const overlay    = drawer.querySelector('[data-rune-overlay]');
  const btnClose   = drawer.querySelector('[data-rune-close]');
  const itemsBox   = document.getElementById('runeCartItems');
  const subtotalEl = document.getElementById('runeCartSubtotal');
  const tpl        = document.getElementById('runeCartTpl');
  const freeTextEl = document.getElementById('runeFreeShipText');
  const freeFillEl = document.getElementById('runeFreeShipFill');

  const FREE_SHIP_THRESHOLD = 6000; // $60.00 in cents

  // open/close
  function openDrawer(){ drawer.setAttribute('aria-hidden','false'); }
  function closeDrawer(){ drawer.setAttribute('aria-hidden','true'); }
  overlay && overlay.addEventListener('click', closeDrawer);
  btnClose && btnClose.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  // money formatter
  function money(cents){
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        const fmt = Shopify.money_format || '${{amount}}';
        return Shopify.formatMoney(cents || 0, fmt);
      }
    } catch(_){}
    return ((cents||0)/100).toLocaleString(undefined,{style:'currency',currency:(Shopify?.currency?.active)||'USD'});
  }

  // best image url
  function bestImageUrl(item){
    const raw = (item.featured_image && (item.featured_image.url || item.featured_image.src)) || item.image || '';
    if (!raw) return '';
    if (/_\d+x\./.test(raw)) return raw;
    return raw.replace(/(\.(?:jpe?g|png|webp))(?:\?.*)?$/i, '_200x$1');
  }

  // cart API
  async function fetchCart(){
    const res = await fetch('/cart.js', {headers:{Accept:'application/json'}});
    return res.json();
  }

  // refresh product page cart count from server
  function refreshPageCartState() {
    fetch('/cart.js', {headers: {Accept: 'application/json'}})
      .then(r => r.json())
      .then(cart => {
        // Update cart icon bubble
        document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(el => {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('a[href="/cart"] .cart-count-bubble').forEach(el => {
          el.setAttribute('aria-label', cart.item_count + ' items');
        });
      });

fetch(window.location.href + '?t=' + Date.now(), {headers: {'Accept': 'text/html', 'Cache-Control': 'no-cache'}})
      .then(r => r.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        // Only update the label text, not the whole quantity-input
        const newLabel = doc.querySelector('.quantity__rules-cart');
        const curLabel = document.querySelector('.quantity__rules-cart');
        if (newLabel && curLabel) {
          curLabel.innerHTML = newLabel.innerHTML;
          curLabel.classList.remove('hidden');
        }
        // Update cart bubble
        const newBubble = doc.querySelector('.cart-count-bubble');
        const curBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
      });
  }

  async function change(key, qty){
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(qty)||0) })
    });
    const cart = await fetchCart();
    draw(cart);
    refreshPageCartState();
  }

  // free shipping bar
  function updateFreeShip(totalCents){
    if (!freeTextEl || !freeFillEl) return;
    const total = Number(totalCents) || 0;
    const left  = Math.max(FREE_SHIP_THRESHOLD - total, 0);
    const pct   = Math.min(100, Math.round((total / FREE_SHIP_THRESHOLD) * 100));
    freeFillEl.style.width = pct + '%';
    freeTextEl.textContent = left > 0
      ? `You're ${money(left)} away from free shipping`
      : `🎉 You've unlocked free shipping!`;
  }

  // render one line item
  function renderItem(item){
    const node    = tpl.content.firstElementChild.cloneNode(true);
    node.dataset.key = item.key;

    const link    = node.querySelector('.runeItem__imgLink');
    const img     = node.querySelector('.runeItem__img');
    const title   = node.querySelector('.runeItem__title');
    const variant = node.querySelector('.runeItem__variant');
    const price   = node.querySelector('.runeItem__price');
    const qtyIn   = node.querySelector('.runeQty__input');

    if (link)    link.href = item.url;
    if (title)  { title.textContent = item.product_title || item.title || ''; title.href = item.url; }
    if (variant)  variant.textContent = item.variant_title || '';
    if (price)    price.textContent = money(item.final_line_price || 0);
    if (qtyIn)    qtyIn.value = item.quantity;

    const src = bestImageUrl(item);
    if (img){
      img.src = src || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      img.alt = item.title || '';
    }

    return node;
  }

  // draw full cart
  function draw(cart){
    itemsBox.innerHTML = '';
    (cart.items || []).forEach(it => itemsBox.appendChild(renderItem(it)));
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price || 0);
    updateFreeShip(cart.total_price || 0);
  }

  // qty +/− and remove
  itemsBox.addEventListener('click', (e) => {
    const row = e.target.closest('[data-key]');
    if (!row) return;
    const key = row.dataset.key;

    if (e.target.closest('.runeItem__remove')) {
      change(key, 0);
      return;
    }

    const deltaBtn = e.target.closest('.runeQty__btn');
    if (deltaBtn) {
      const delta = Number(deltaBtn.dataset.delta || 0);
      const input = row.querySelector('.runeQty__input');
      const next  = Math.max(0, Number(input.value || 0) + delta);
      change(key, next);
    }
  });

  itemsBox.addEventListener('change', (e) => {
    const input = e.target.closest('.runeQty__input');
    if (!input) return;
    const row = input.closest('[data-key]');
    if (!row) return;
    change(row.dataset.key, input.value);
  });

  // Intercept add-to-cart, prevent Shopify's native handler, open our drawer
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.dataset.runeSubmitting) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    form.dataset.runeSubmitting = 'true';
    (async () => {
      try {
        const fd = new FormData(form);
        await fetch('/cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:fd});
        const cart = await fetchCart();
        draw(cart);
        openDrawer();
        refreshPageCartState();
      } catch(_) {
        location.href = '/cart';
      } finally {
        delete form.dataset.runeSubmitting;
      }
    })();
  }, true);

})();

/* Tag cart-page upsell blocks */
document.addEventListener('DOMContentLoaded', function () {
  const upsells = document.querySelectorAll(
    '.cart-items .cart-item .complementary-products, ' +
    '.cart-items .cart-item [class*="complementary"], ' +
    '.cart-items .cart-item [data-upsell], ' +
    '.cart-items .cart-item .rc__upsell, ' +
    '.cart-items .cart-item .rc-widget-injected'
  );
  upsells.forEach(el => el.classList.add('rjc-upsell'));
});